export const getPriceList = () => ({
  type: "@saga/GET_PRICE_LIST",
});
